export default __webpack_public_path__ + "static/media/3-1-4.42a1ec6b.jpg";